import { footerAbout, footerLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200/70 pt-14 md:pt-20 pb-8">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading text-primary-500 mb-3 block">
              51吃瓜官网
            </span>
            <p className="text-xs text-foreground-500 leading-relaxed mb-4">
              {footerAbout}
            </p>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-800 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-800 mb-4">服务支持</h3>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-800 mb-4">合作伙伴</h3>
            <p className="text-xs text-foreground-400 leading-relaxed">
              诚邀优质内容平台与流量渠道合作，共建吃瓜内容生态。具体合作方信息更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-300/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2023-2026 51吃瓜官网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400">51吃瓜官网全网最新入口</span>
            <span className="text-[10px] text-foreground-300">|</span>
            <span className="text-xs text-foreground-400">51吃瓜入口网址大全</span>
          </div>
        </div>
      </div>
    </footer>
  );
}